import React from 'react';
import { useTranslation } from 'react-i18next';

interface AddPersonaPlaceholderCardProps {
  onClick: () => void;
}

const AddPersonaPlaceholderCard: React.FC<AddPersonaPlaceholderCardProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      type="button"
      className="flex flex-col items-center justify-center p-4 border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:border-indigo-500 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-150 ease-in-out h-full min-h-[150px] w-full"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-8 w-8 mb-2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
      <span className="text-sm font-medium text-center">{t('useCases.addPersona', 'Add Persona')}</span>
    </button>
  );
};

export default AddPersonaPlaceholderCard;
